import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as settings from "../../constants/settings";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as windowService from "../windowService";

export const processWebsocketResponse = (tabId, method, response, state) => {
    if (state.searchPanel[tabId] === undefined) {
        windowService.logDebug("Tab (" + tabId + ") was closed before search request was finished.");

        return [];
    }

    switch (method) {
        case handlers.GET_PRODUCTS_BY_PARAMS:
            if (!responseHelper.isGroupListFormatValid(response, state.settings.productGroups)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        productList: response.data,
                        productGroups: state.settings.productGroups
                    }
                }
            ];
        case handlers.GET_PRODUCTS_WITH_AUTOSELECT:
            if (!responseHelper.isGroupListFormatValid(response, state.settings.productGroups)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_LIST_SEARCH_WITH_AUTOSELECT,
                    payload: {
                        tabId: tabId,
                        productList: response.data,
                        productGroups: state.settings.productGroups
                    }
                }
            ];
        case handlers.GET_FANDECKS_BY_PARAMS:
            if (
                !responseHelper.isFandeckGroupListFormatValid(
                    response,
                    state.settings.fandeckGroups,
                    state.searchPanel[tabId].local
                )
            ) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        fandeckList: response.data,
                        fandeckGroups: state.settings.fandeckGroups
                    }
                }
            ];
        case handlers.GET_FANDECKS_WITH_AUTOSELECT:
            if (
                !responseHelper.isFandeckGroupListFormatValid(
                    response,
                    state.settings.fandeckGroups,
                    state.searchPanel[tabId].local
                )
            ) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_LIST_SEARCH_WITH_AUTOSELECT,
                    payload: {
                        tabId: tabId,
                        fandeckList: response.data,
                        fandeckGroups: state.settings.fandeckGroups
                    }
                }
            ];
        case handlers.GET_FANDECKS_WITH_OFFSET:
            if (
                !responseHelper.isFandeckGroupListFormatValid(
                    response,
                    state.settings.fandeckGroups,
                    state.searchPanel[tabId].local
                )
            ) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_LIST_SEARCH_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        fandeckList: response.data,
                        fandeckGroups: state.settings.fandeckGroups
                    }
                }
            ];
        case handlers.GET_COLORS_BY_PARAMS_INIT:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_LIST_SEARCH_INIT,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLOR_CODES_BY_PARAMS_INIT:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_CODE_LIST_SEARCH_INIT,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLORS_BY_PARAMS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLORS_WITH_AUTOSELECT:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_LIST_SEARCH_WITH_AUTOSELECT,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLOR_CODES_BY_PARAMS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_CODE_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLORS_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_LIST_SEARCH_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_COLOR_CODES_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_CODE_LIST_SEARCH_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.GET_BASES_BY_PARAMS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BASE_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        baseList: response.data
                    }
                }
            ];
        case handlers.GET_BASES_WITH_AUTOSELECT:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BASE_LIST_SEARCH_WITH_AUTOSELECT,
                    payload: {
                        tabId: tabId,
                        baseList: response.data
                    }
                }
            ];
        case handlers.GET_BASES_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BASE_LIST_SEARCH_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        baseList: response.data
                    }
                }
            ];
        case handlers.GET_BIPP_BY_PARAMS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BIPP_LIST_SEARCH,
                    payload: {
                        tabId: tabId,
                        bippList: response.data
                    }
                }
            ];
        case handlers.GET_BIPP_WITH_AUTOSELECT:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BIPP_LIST_SEARCH_WITH_AUTOSELECT,
                    payload: {
                        tabId: tabId,
                        bippList: response.data
                    }
                }
            ];
        case handlers.GET_BIPP_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BIPP_LIST_SEARCH_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        bippList: response.data
                    }
                }
            ];
        case handlers.BROWSE_CIF:
            if (!responseHelper.isBrowseColorsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data.length === 0) {
                return [
                    {
                        type: actionTypes.SAVE_BROWSE_COLOR_LIST,
                        payload: {
                            tabId: tabId,
                            data: [],
                            formulaListOffset: state.settings.colorTabRowCount
                        }
                    }
                ];
            }

            let browseResponse = [
                {
                    type: actionTypes.SAVE_BROWSE_COLOR_LIST,
                    payload: {
                        tabId: tabId,
                        data: modelHelper.mapBrowseColorsToObjects(response.data, false),
                        formulaListOffset:
                            Math.ceil(response.data.length / state.settings.colorTabRowCount) *
                            state.settings.colorTabRowCount
                    }
                }
            ];

            /* eslint-disable-next-line no-undef */
            let images = new Set();

            for (let formula of response.data) {
                if (formula.moreInfoParsed !== null && formula.moreInfoParsed.formulaNoteImages.length > 0) {
                    for (let formulaNoteId of formula.moreInfoParsed.formulaNoteImages) {
                        images.add(formulaNoteId);
                    }
                }
            }

            for (let formulaNoteId of images.values()) {
                if (window.imageStore.getFormulaNoteImageById(formulaNoteId) === null) {
                    browseResponse.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_FORMULA_NOTE_IMAGE,
                            params: {
                                formulaNoteId: formulaNoteId,
                                online: state.settings.imagesSource === settings.SOURCE_ONLINE
                            }
                        },
                        method: handlers.GET_FORMULA_NOTE_IMAGE,
                        tabId: componentTypes.NO_SKIP_TAB_ID
                    });
                }
            }

            return browseResponse;
        case handlers.BROWSE_CIF_WITH_OFFSET:
            if (!responseHelper.isBrowseColorsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let browseWithOffset = [
                {
                    type: actionTypes.SAVE_BROWSE_COLOR_LIST_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        data: modelHelper.mapBrowseColorsToObjects(response.data, false),
                        formulaListOffset: state.settings.colorTabRowCount
                    }
                }
            ];

            /* eslint-disable-next-line no-undef */
            let imagesWithOffset = new Set();

            for (let formula of response.data) {
                if (formula.moreInfoParsed !== null && formula.moreInfoParsed.formulaNoteImages.length > 0) {
                    for (let formulaNoteId of formula.moreInfoParsed.formulaNoteImages) {
                        imagesWithOffset.add(formulaNoteId);
                    }
                }
            }

            for (let formulaNoteId of imagesWithOffset.values()) {
                if (window.imageStore.getFormulaNoteImageById(formulaNoteId) === null) {
                    browseWithOffset.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_FORMULA_NOTE_IMAGE,
                            params: {
                                formulaNoteId: formulaNoteId,
                                online: state.settings.imagesSource === settings.SOURCE_ONLINE
                            }
                        },
                        method: handlers.GET_FORMULA_NOTE_IMAGE,
                        tabId: componentTypes.NO_SKIP_TAB_ID
                    });
                }
            }

            return browseWithOffset;
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
